/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'sr',
  Pagination: {
    items_per_page: '/ strani',
    jump_to: 'Idi na',
    page: '',
    prev_page: 'Prethodna strana',
    next_page: 'Sledeća strana',
    prev_5: 'Prethodnih 5 Strana',
    next_5: 'Sledećih 5 Strana',
    prev_3: 'Prethodnih 3 Strane',
    next_3: 'Sledećih 3 Strane'
  },
  DatePicker: {
    lang: {
      placeholder: 'Izaberite datum',
      rangePlaceholder: ['Početni datum', 'Krajnji datum'],
      locale: 'sr_RS',
      today: 'Danas',
      now: 'Sada',
      backToToday: 'Vrati se na danas',
      ok: 'U redu',
      clear: 'Obriši',
      month: 'Mesec',
      year: 'Godina',
      timeSelect: 'Izaberi vreme',
      dateSelect: 'Izaberi datum',
      monthSelect: 'Izaberi mesec',
      yearSelect: 'Izaberi godinu',
      decadeSelect: 'Izaberi deceniju',
      yearFormat: 'YYYY',
      dateFormat: 'DD.MM.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prethodni mesec (PageUp)',
      nextMonth: 'Sledeći mesec (PageDown)',
      previousYear: 'Prethodna godina (Control + left)',
      nextYear: 'Sledeća godina (Control + right)',
      previousDecade: 'Prethodna decenija',
      nextDecade: 'Sledeća decenija',
      previousCentury: 'Prethodni vek',
      nextCentury: 'Sledeći vek'
    },
    timePickerLocale: {
      placeholder: 'Izaberite vreme'
    }
  },
  TimePicker: {
    placeholder: 'Izaberite vreme'
  },
  Calendar: {
    lang: {
      placeholder: 'Izaberite datum',
      rangePlaceholder: ['Početni datum', 'Krajnji datum'],
      locale: 'sr_RS',
      today: 'Danas',
      now: 'Sada',
      backToToday: 'Vrati se na danas',
      ok: 'U redu',
      clear: 'Obriši',
      month: 'Mesec',
      year: 'Godina',
      timeSelect: 'Izaberi vreme',
      dateSelect: 'Izaberi datum',
      monthSelect: 'Izaberi mesec',
      yearSelect: 'Izaberi godinu',
      decadeSelect: 'Izaberi deceniju',
      yearFormat: 'YYYY',
      dateFormat: 'DD.MM.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prethodni mesec (PageUp)',
      nextMonth: 'Sledeći mesec (PageDown)',
      previousYear: 'Prethodna godina (Control + left)',
      nextYear: 'Sledeća godina (Control + right)',
      previousDecade: 'Prethodna decenija',
      nextDecade: 'Sledeća decenija',
      previousCentury: 'Prethodni vek',
      nextCentury: 'Sledeći vek'
    },
    timePickerLocale: {
      placeholder: 'Izaberite vreme'
    }
  },
  Table: {
    filterTitle: 'Filter',
    filterConfirm: 'Primeni filter',
    filterReset: 'Resetuj filter',
    selectAll: 'Obeleži sve na trenutnoj strani',
    selectInvert: 'Obrni selekciju na trenutnoj stranici'
  },
  Modal: {
    okText: 'U redu',
    cancelText: 'Otkaži',
    justOkText: 'U redu'
  },
  Popconfirm: {
    okText: 'U redu',
    cancelText: 'Otkaži'
  },
  Transfer: {
    searchPlaceholder: 'Pretražite ovde',
    itemUnit: 'stavka',
    itemsUnit: 'stavki'
  },
  Upload: {
    uploading: 'Slanje...',
    removeFile: 'Ukloni fajl',
    uploadError: 'Greška prilikom slanja',
    previewFile: 'Pogledaj fajl',
    downloadFile: 'Preuzmi datoteku'
  },
  Empty: {
    description: 'Nema podataka'
  }
};
